import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleButton as FluentToggleButton, makeStyles } from "@fluentui/react-components";
import { useCallback, useContext, useEffect, useState } from "react";
import { ToolContext } from "../hoc/fluentToolWrapper";
import { Tooltip } from "./tooltip";
const useStyles = makeStyles({
    button: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});
/**
 * Toggles between two states using a button with icons.
 * If no disabledIcon is provided, the button will toggle between visual enabled/disabled states without an icon change
 *
 * @param props
 * @returns
 */
export const ToggleButton = (props) => {
    ToggleButton.displayName = "ToggleButton";
    const { value, onChange, title, appearance = "subtle" } = props;
    const { size } = useContext(ToolContext);
    const classes = useStyles();
    const [checked, setChecked] = useState(value);
    const toggle = useCallback(() => {
        setChecked((prevChecked) => {
            const enabled = !prevChecked;
            onChange(enabled);
            return enabled;
        });
    }, [onChange]);
    useEffect(() => {
        setChecked(props.value);
    }, [props.value]);
    return (_jsx(Tooltip, { content: title ?? "", children: _jsx(FluentToggleButton, { className: classes.button, size: size, icon: checked ? _jsx(props.checkedIcon, {}) : props.uncheckedIcon ? _jsx(props.uncheckedIcon, {}) : _jsx(props.checkedIcon, {}), appearance: appearance, checked: checked, onClick: toggle }) }));
};
//# sourceMappingURL=toggleButton.js.map